import cx from "classnames";

import styles from "./styles.module.scss";

const RadioButton = (props) => {
  const {
    label,
    name,
    value,
    checked,
    onChange,
    disabled = false,
    className,
    ...restProps
  } = props;

  return (
    <label
      className={cx(
        styles.radioWrapper,
        disabled && styles.disabled,
        className,
      )}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.radioInput}
        {...restProps}
      />

      <span className={styles.customRadio} />

      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
};

export default RadioButton;
